module.exports = __webpack_public_path__ + "static/media/payCasaChavez.e5b02feb.png";